import { useState } from "react";
import GoogleMapSearch from "../../../../common/components/google-map-search";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";


export default function LocationDetails({ shippingTypesDetails, packageItem, dropLocations, setDropLocation, pickupLocations, setPickupLocation, libraryData, quoteData, handleBackSteps, handleSteps, handleChange }: any) {


  const [currentIndex, setCurrentIndex] = useState(0);

  const handleRightScroll = () => {
    if (currentIndex < packageItem.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleLeftScroll = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  };
  return (
    <div className="flex flex-row justify-center  items-center  h-screen">
      <div className="overflow-auto h-[600px] bg-white shadow-xl m-3 w-[400px] min-w-[400px]">
        <div className="flex flex-col justify-center items-start p-6 space-y-5">
          <div className='text-xl font-semibold '>Order Summary</div>
          <div className="w-full flex items-center justify-between p-2 border-b border-black">
            <div className="text-lg font-semibold ">
              Package Details
            </div>
            <div className="pl-32">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>

          <div className="w-full flex items-center justify-between">
            <div className="cursor-pointer  hover:text-hilight opacity-50 hover:opacity-100">
              <IoIosArrowBack size={20} onClick={handleLeftScroll} />
            </div>
            {packageItem?.slice(currentIndex, currentIndex + 1)?.map((packageItemData: any, index: any) => (
              <div key={index} className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mx-2">
                <div className="pb-4">
                  <label className="text-md font-semibold block">Product</label>
                  <label className="text-base block mt-1">{packageItemData.productName}</label>
                </div>
                <div className="pb-4">
                  <label className="text-md font-semibold block">Weight</label>
                  <label className="text-base block mt-1">{packageItemData.weight} kg</label>
                </div>
                <div className="pb-4">
                  <label className="text-md font-semibold block">Product Category</label>
                  <label className="text-base block mt-1">{packageItemData.categoryName}</label>
                </div>
                <div className="pb-4">
                  <label className="text-md font-semibold block">Package Value</label>
                  <label className="text-base block mt-1">₹ {packageItemData.value}</label>
                </div>
              </div>
            ))}
            <div className="cursor-pointer  hover:text-hilight opacity-50 hover:opacity-100">
              <IoIosArrowForward size={20} onClick={handleRightScroll} />
            </div>
          </div>
          <div className="w-full flex items-center justify-between p-2 border-b border-black">
            <div className="text-lg font-semibold ">
              Address Details
            </div>
            <div className="pl-32">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
          <div className="mt-2 grid grid-cols-1 md:grid-cols-1 gap-4">
            <div className="mb-1 ">
              <label className="text-md font-semibold block">
                Pickup Address
              </label>
              <label className="text-base block mt-1">
                {pickupLocations?.description}
              </label>
            </div>
            <div className="mb-1 ">
              <label className="text-md font-semibold block">
                Drop Address
              </label>
              <label className="text-base block mt-1">
                {dropLocations?.description}
              </label>
            </div>
            <div className="mb-1 ">
              <label className="text-lg pr-5 font-semibold">
                Shipping Option
              </label>
              <label className="text-base ">
                {quoteData?.shipping}
              </label>
            </div>

          </div>
        </div>

      </div>
      <div className="overflow-auto min-h-[600px] max-h-[600px] bg-white shadow-xl m-3 min-w-[900px]">
        <div className="flex flex-col justify-center items-start p-5 space-y-5">
          <div className="text-xl font-semibold">Location Details</div>

          <div className="flex flex-wrap justify-between p-4 w-full space-y-4 md:space-y-0">


            {/* First "New Item" Section */}
            <div className="w-full md:w-[48%]"> {/* Adjust the width for side-by-side layout */}
              <div className="text-md font-normal p-4">Pickup Address</div>
              <div className="grid grid-cols-1 gap-4 w-full p-4">
                <div className=" w-full border-b border-black  rounded">
                  <input
                    required
                    type="text"
                    name="pickupContactName"
                    placeholder="Contact Name *"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(
                        event.target.value,
                        'pickupContactName'
                      )
                    }}
                    value={quoteData?.pickupContactName}
                  />
                </div>
                {/* <div className=" w-full border-b border-black  rounded">
                  <input
                    type="text"
                    name="pickupEmail"
                    placeholder="Email"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(
                        event.target.value,
                        'pickupEmail'
                      )
                    }}
                    value={quoteData?.pickupEmail}
                  />
                </div> */}
                <div className=" w-full border-b border-black  rounded">
                  <input
                    required
                    maxLength={10}
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number *"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(
                        event.target.value.replace(/\D/g, ''),
                        'pickupMobileNumber'
                      )
                    }}
                    value={quoteData?.pickupMobileNumber}
                  />

                </div>
                {quoteData?.pickupMobileNumber && quoteData?.pickupMobileNumber?.length < 10 && (
                  <span className="text-red-600 text-xs">
                    Please enter a valid number.
                  </span>
                )}
                <div className=" w-full  rounded">
                  <GoogleMapSearch
                    setLocation={setPickupLocation}
                    location={pickupLocations}
                    placeholder="Pickup Address *"
                    required />
                </div>
                <div className="w-full   rounded">
                  <textarea
                    name={"additionainfo"}
                    placeholder="Additional info"
                    className={`w-full h-12 border-b border-black placeholder-black px-4 py-3`}
                    onChange={(event: any) => {
                      handleChange(
                        event.target.value,
                        'pickupAdditionaInfo'
                      )
                    }}
                    value={quoteData?.pickupAdditionaInfo}
                  />
                </div>
              </div>
            </div>

            {/* Second "New Item" Section */}
            <div className="w-full md:w-[48%]"> {/* Adjust the width for side-by-side layout */}
              <div className="text-md font-normal p-4">Drop Address</div>
              <div className="grid grid-cols-1 gap-4 w-full p-4">
                <div className=" w-full border-b border-black  rounded">
                  <input
                    required
                    type="text"
                    name="dropContactName"
                    placeholder="Contact Name *"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(
                        event.target.value,
                        'dropContactName'
                      )
                    }}
                    value={quoteData?.dropContactName}
                  />
                </div>
                {/* <div className=" w-full border-b border-black  rounded">
                  <input

                    type="text"
                    name="dropEmail"
                    placeholder="Email"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(
                        event.target.value,
                        'dropEmail'
                      )
                    }}
                    value={quoteData?.dropEmail}
                  />
                </div> */}
                <div className=" w-full border-b border-black  rounded">
                  <input
                    required
                    maxLength={10}
                    type="text"
                    name="droMobileNumber"
                    placeholder="Mobile Number *"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(
                        event.target.value.replace(/\D/g, ''),
                        'dropMobileNumber'
                      )
                    }}
                    value={quoteData?.dropMobileNumber}
                  />

                </div>
                {quoteData?.dropMobileNumber && quoteData?.dropMobileNumber?.length < 10 && (
                  <span className="text-red-600 text-xs">
                    Please enter a valid number.
                  </span>
                )}
                <div className=" w-full rounded ">
                  <GoogleMapSearch
                    setLocation={setDropLocation}
                    location={dropLocations}
                    placeholder="Drop Address *"
                    required />

                </div>
                <div className="w-full   rounded">
                  <textarea
                    name="dropAdditionaInfo"
                    placeholder="Additional info"
                    className={`w-full h-12 border-b border-black  placeholder-black px-4 py-3`}
                    onChange={(event: any) => {
                      handleChange(
                        event.target.value,
                        'dropAdditionaInfo'
                      )
                    }}
                    value={quoteData?.dropAdditionaInfo}
                  />
                </div>
              </div>
            </div>
            {/* <div className="m-4 w-full">
              <div className=" w-full border-b border-black  rounded">
                <select
                  className="w-full rounded bg-opacity-0  py-2"
                  id="default"
                  onChange={(event: any) => {
                    handleChange(
                      event.target.value,
                      'shippingType'
                    )
                  }}
                  value={quoteData?.shippingType}
                >
                  <option>Shipping type</option>
                  {shippingTypesDetails.result.items?.map((item: any, index: any) => (
                    <option value={item.Id} key={index}>{item.ShippingTypeName}</option>
                  )
                  )}
                </select>
              </div>
            </div> */}
            <div className="m-4 w-full">
              <div className=" w-full border-b border-black  rounded">
                <select
                  className="w-full rounded bg-opacity-0  py-2"
                  id="default"
                  onChange={(event: any) => {
                    handleChange(
                      event.target.value,
                      'shipping'
                    )
                  }}
                  value={quoteData?.shipping}
                >
                  <option>Shipping Option *</option>
                  {libraryData?.result?.ShippingOption?.map((item: any, index: any) => (
                    <option value={item.Text} key={index}>{item.Text}</option>
                  )
                  )}
                </select>
              </div>
            </div>

          </div>


          <div className='w-full flex justify-end px-10 space-x-3'>
            <button
              onClick={handleBackSteps}
              className='px-4 py-2 bg-primary text-light'>Back</button>
            <button
              onClick={handleSteps}
              className='px-4 py-2 bg-primary text-light'>Next</button>
          </div>
        </div>
      </div>

    </div >

  );
}
